import { useCallback } from "react";

import type * as Type from "../type";

type Props = {
	hotelID: string;
	// 検索日
	initSearchDate: string;
};

export const useViewModelConverter = () => {
	const onConvertViewModel = useCallback(
		({ hotelID, initSearchDate }: Props): Type.ViewModel => ({
			hotelID,
			guestName: {
				value: "",
				errorMessage: "お客様のお名前は必須項目です",
			},
			guestTel: {
				value: "登録なし",
				errorMessage: undefined,
			},
			date: initSearchDate,
			optionID: {
				value: "",
				errorMessage: "オプションを選択してください",
			},
			amount: {
				value: undefined,
				errorMessage: undefined,
			},
			comment: {
				value: "",
				errorMessage: undefined,
			},
		}),
		[],
	);

	return {
		onConvertViewModel,
	};
};
